import React, { lazy, Suspense } from 'react';

import { TextOverrides } from '../shop-tires-flow/components/need-help-finding-tires/need-help-finding-tires';

import { Fitment } from '../../shared/types/fitment';

import './fitment-shop-tires-flow.scss';

const ShopTiresFlow = lazy(
  () =>
    import(
      /* webpackChunkName: "shop-tires-flow" */
      '../shop-tires-flow/shop-tires-flow'
    )
);

interface FitmentShopTiresFlowProps {
  fitment: Fitment;
  handleBackClick?: () => void;
  handleStartTreadwell?: () => void;
  setViewState: React.Dispatch<string>;
  showTopBackLink?: boolean;
  textOverrides?: TextOverrides;
  viewState: string;
}

function FitmentShopTiresFlow(props: FitmentShopTiresFlowProps) {
  const {
    fitment,
    handleBackClick,
    handleStartTreadwell,
    setViewState,
    showTopBackLink,
    textOverrides,
    viewState
  } = props;

  return (
    <Suspense fallback={<div />}>
      <ShopTiresFlow
        fitment={fitment}
        handleBackClick={handleBackClick}
        handleStartTreadwell={handleStartTreadwell}
        hideBackButton
        setViewState={setViewState}
        showSubmitButton
        showTopBackLink={showTopBackLink}
        styleName="shop-tires"
        textOverrides={textOverrides}
        viewState={viewState}
      />
    </Suspense>
  );
}

export default FitmentShopTiresFlow;
